export default __webpack_public_path__ + "521cb3d7e3e9a56b53fd108c0108c4e9.png";